<template>
  <v-panel>
    <v-form ref="form">
      <div class="divider">
        <span>
          <b>Dados dos Recursos - Instalações e Benfeitorias</b>
        </span>
      </div>
      <v-flex md11>
        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Instalações e benfeitorias</b>
          </span>
        </div>
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <!--quero mandar isso para o manutenção-->
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloInstalacoes01"
                  placeholder="Itens"
                  v-model="formulario.TituloInstalacoes01"
                  background-color="white"
                  @input="emitirMudancaDeTitulo1(formulario.TituloInstalacoes01)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesUnidade01"
                  v-model="formulario.InstalacoesUnidade01"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesQuantidade01"
                  v-model="formulario.InstalacoesQuantidade01"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorInicial01"
                      v-model="formulario.InstalacoesValorInicial01"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorResidual01"
                      v-model="formulario.InstalacoesValorResidual01"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesVidaUtil01"
                  v-model="formulario.InstalacoesVidaUtil01"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesBovinoCultura01"
                  v-model="formulario.InstalacoesBovinoCultura01"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloInstalacoes02"
                  placeholder="Itens"
                  v-model="formulario.TituloInstalacoes02"
                  background-color="white"
                  @input="emitirMudancaDeTitulo2(formulario.TituloInstalacoes02)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesUnidade02"
                  v-model="formulario.InstalacoesUnidade02"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesQuantidade02"
                  v-model="formulario.InstalacoesQuantidade02"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorInicial02"
                      v-model="formulario.InstalacoesValorInicial02"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorResidual02"
                      v-model="formulario.InstalacoesValorResidual02"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesVidaUtil02"
                  v-model="formulario.InstalacoesVidaUtil02"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesBovinoCultura02"
                  v-model="formulario.InstalacoesBovinoCultura02"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloInstalacoes03"
                  placeholder="Itens"
                  v-model="formulario.TituloInstalacoes03"
                  background-color="white"
                  @input="emitirMudancaDeTitulo3(formulario.TituloInstalacoes03)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesUnidade03"
                  v-model="formulario.InstalacoesUnidade03"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesQuantidade03"
                  v-model="formulario.InstalacoesQuantidade03"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorInicial03"
                      v-model="formulario.InstalacoesValorInicial03"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorResidual03"
                      v-model="formulario.InstalacoesValorResidual03"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesVidaUtil03"
                  v-model="formulario.InstalacoesVidaUtil03"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesBovinoCultura03"
                  v-model="formulario.InstalacoesBovinoCultura03"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloInstalacoes04"
                  placeholder="Itens"
                  v-model="formulario.TituloInstalacoes04"
                  background-color="white"
                  @input="emitirMudancaDeTitulo4(formulario.TituloInstalacoes04)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesUnidade04"
                  v-model="formulario.InstalacoesUnidade04"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesQuantidade04"
                  v-model="formulario.InstalacoesQuantidade04"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorInicial04"
                      v-model="formulario.InstalacoesValorInicial04"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorResidual04"
                      v-model="formulario.InstalacoesValorResidual04"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesVidaUtil04"
                  v-model="formulario.InstalacoesVidaUtil04"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesBovinoCultura04"
                  v-model="formulario.InstalacoesBovinoCultura04"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloInstalacoes05"
                  placeholder="Itens"
                  v-model="formulario.TituloInstalacoes05"
                  background-color="white"
                  @input="emitirMudancaDeTitulo5(formulario.TituloInstalacoes05)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesUnidade05"
                  v-model="formulario.InstalacoesUnidade05"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesQuantidade05"
                  v-model="formulario.InstalacoesQuantidade05"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorInicial05"
                      v-model="formulario.InstalacoesValorInicial05"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorResidual05"
                      v-model="formulario.InstalacoesValorResidual05"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesVidaUtil05"
                  v-model="formulario.InstalacoesVidaUtil05"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesBovinoCultura05"
                  v-model="formulario.InstalacoesBovinoCultura05"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloInstalacoes06"
                  placeholder="Itens"
                  v-model="formulario.TituloInstalacoes06"
                  background-color="white"
                  @input="emitirMudancaDeTitulo6(formulario.TituloInstalacoes06)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesUnidade06"
                  v-model="formulario.InstalacoesUnidade06"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesQuantidade06"
                  v-model="formulario.InstalacoesQuantidade06"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorInicial06"
                      v-model="formulario.InstalacoesValorInicial06"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorResidual06"
                      v-model="formulario.InstalacoesValorResidual06"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesVidaUtil06"
                  v-model="formulario.InstalacoesVidaUtil06"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesBovinoCultura06"
                  v-model="formulario.InstalacoesBovinoCultura06"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloInstalacoes07"
                  placeholder="Itens"
                  v-model="formulario.TituloInstalacoes07"
                  background-color="white"
                  @input="emitirMudancaDeTitulo7(formulario.TituloInstalacoes07)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesUnidade07"
                  v-model="formulario.InstalacoesUnidade07"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesQuantidade07"
                  v-model="formulario.InstalacoesQuantidade07"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorInicial07"
                      v-model="formulario.InstalacoesValorInicial07"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorResidual07"
                      v-model="formulario.InstalacoesValorResidual07"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesVidaUtil07"
                  v-model="formulario.InstalacoesVidaUtil07"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesBovinoCultura07"
                  v-model="formulario.InstalacoesBovinoCultura07"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloInstalacoes08"
                  placeholder="Itens"
                  v-model="formulario.TituloInstalacoes08"
                  background-color="white"
                  @input="emitirMudancaDeTitulo8(formulario.TituloInstalacoes08)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesUnidade08"
                  v-model="formulario.InstalacoesUnidade08"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesQuantidade08"
                  v-model="formulario.InstalacoesQuantidade08"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorInicial08"
                      v-model="formulario.InstalacoesValorInicial08"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorResidual08"
                      v-model="formulario.InstalacoesValorResidual08"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesVidaUtil08"
                  v-model="formulario.InstalacoesVidaUtil08"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesBovinoCultura08"
                  v-model="formulario.InstalacoesBovinoCultura08"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloInstalacoes09"
                  placeholder="Itens"
                  v-model="formulario.TituloInstalacoes09"
                  background-color="white"
                  @input="emitirMudancaDeTitulo9(formulario.TituloInstalacoes09)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesUnidade09"
                  v-model="formulario.InstalacoesUnidade09"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesQuantidade09"
                  v-model="formulario.InstalacoesQuantidade09"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorInicial09"
                      v-model="formulario.InstalacoesValorInicial09"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorResidual09"
                      v-model="formulario.InstalacoesValorResidual09"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesVidaUtil09"
                  v-model="formulario.InstalacoesVidaUtil09"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesBovinoCultura09"
                  v-model="formulario.InstalacoesBovinoCultura09"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloInstalacoes10"
                  placeholder="Itens"
                  v-model="formulario.TituloInstalacoes10"
                  background-color="white"
                  @input="emitirMudancaDeTitulo10(formulario.TituloInstalacoes10)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesUnidade10"
                  v-model="formulario.InstalacoesUnidade10"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesQuantidade10"
                  v-model="formulario.InstalacoesQuantidade10"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorInicial10"
                      v-model="formulario.InstalacoesValorInicial10"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorResidual10"
                      v-model="formulario.InstalacoesValorResidual10"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesVidaUtil10"
                  v-model="formulario.InstalacoesVidaUtil10"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesBovinoCultura10"
                  v-model="formulario.InstalacoesBovinoCultura10"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloInstalacoes11"
                  placeholder="Itens"
                  v-model="formulario.TituloInstalacoes11"
                  background-color="white"
                  @input="emitirMudancaDeTitulo11(formulario.TituloInstalacoes11)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesUnidade11"
                  v-model="formulario.InstalacoesUnidade11"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesQuantidade11"
                  v-model="formulario.InstalacoesQuantidade11"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorInicial11"
                      v-model="formulario.InstalacoesValorInicial11"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorResidual11"
                      v-model="formulario.InstalacoesValorResidual11"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesVidaUtil11"
                  v-model="formulario.InstalacoesVidaUtil11"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesBovinoCultura11"
                  v-model="formulario.InstalacoesBovinoCultura11"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloInstalacoes12"
                  placeholder="Itens"
                  v-model="formulario.TituloInstalacoes12"
                  background-color="white"
                  @input="emitirMudancaDeTitulo12(formulario.TituloInstalacoes12)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesUnidade12"
                  v-model="formulario.InstalacoesUnidade12"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesQuantidade12"
                  v-model="formulario.InstalacoesQuantidade12"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorInicial12"
                      v-model="formulario.InstalacoesValorInicial12"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorResidual12"
                      v-model="formulario.InstalacoesValorResidual12"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesVidaUtil12"
                  v-model="formulario.InstalacoesVidaUtil12"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesBovinoCultura12"
                  v-model="formulario.InstalacoesBovinoCultura12"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloInstalacoes13"
                  placeholder="Itens"
                  v-model="formulario.TituloInstalacoes13"
                  background-color="white"
                  @input="emitirMudancaDeTitulo13(formulario.TituloInstalacoes13)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesUnidade13"
                  v-model="formulario.InstalacoesUnidade13"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesQuantidade13"
                  v-model="formulario.InstalacoesQuantidade13"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorInicial13"
                      v-model="formulario.InstalacoesValorInicial13"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorResidual13"
                      v-model="formulario.InstalacoesValorResidual13"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesVidaUtil13"
                  v-model="formulario.InstalacoesVidaUtil13"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesBovinoCultura13"
                  v-model="formulario.InstalacoesBovinoCultura13"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloInstalacoes14"
                  placeholder="Itens"
                  v-model="formulario.TituloInstalacoes14"
                  background-color="white"
                  @input="emitirMudancaDeTitulo14(formulario.TituloInstalacoes14)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesUnidade14"
                  v-model="formulario.InstalacoesUnidade14"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesQuantidade14"
                  v-model="formulario.InstalacoesQuantidade14"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorInicial14"
                      v-model="formulario.InstalacoesValorInicial14"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorResidual14"
                      v-model="formulario.InstalacoesValorResidual14"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesVidaUtil14"
                  v-model="formulario.InstalacoesVidaUtil14"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesBovinoCultura14"
                  v-model="formulario.InstalacoesBovinoCultura14"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloInstalacoes15"
                  placeholder="Itens"
                  v-model="formulario.TituloInstalacoes15"
                  background-color="white"
                  @input="emitirMudancaDeTitulo15(formulario.TituloInstalacoes15)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesUnidade15"
                  v-model="formulario.InstalacoesUnidade15"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesQuantidade15"
                  v-model="formulario.InstalacoesQuantidade15"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorInicial15"
                      v-model="formulario.InstalacoesValorInicial15"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorResidual15"
                      v-model="formulario.InstalacoesValorResidual15"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesVidaUtil15"
                  v-model="formulario.InstalacoesVidaUtil15"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesBovinoCultura15"
                  v-model="formulario.InstalacoesBovinoCultura15"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloInstalacoes16"
                  placeholder="Itens"
                  v-model="formulario.TituloInstalacoes16"
                  background-color="white"
                  @input="emitirMudancaDeTitulo16(formulario.TituloInstalacoes16)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesUnidade16"
                  v-model="formulario.InstalacoesUnidade16"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesQuantidade16"
                  v-model="formulario.InstalacoesQuantidade16"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorInicial16"
                      v-model="formulario.InstalacoesValorInicial16"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorResidual16"
                      v-model="formulario.InstalacoesValorResidual16"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesVidaUtil16"
                  v-model="formulario.InstalacoesVidaUtil16"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesBovinoCultura16"
                  v-model="formulario.InstalacoesBovinoCultura16"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloInstalacoes17"
                  placeholder="Itens"
                  v-model="formulario.TituloInstalacoes17"
                  background-color="white"
                  @input="emitirMudancaDeTitulo17(formulario.TituloInstalacoes17)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesUnidade17"
                  v-model="formulario.InstalacoesUnidade17"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesQuantidade17"
                  v-model="formulario.InstalacoesQuantidade17"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorInicial17"
                      v-model="formulario.InstalacoesValorInicial17"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorResidual17"
                      v-model="formulario.InstalacoesValorResidual17"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesVidaUtil17"
                  v-model="formulario.InstalacoesVidaUtil17"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesBovinoCultura17"
                  v-model="formulario.InstalacoesBovinoCultura17"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloInstalacoes18"
                  placeholder="Itens"
                  v-model="formulario.TituloInstalacoes18"
                  background-color="white"
                  @input="emitirMudancaDeTitulo18(formulario.TituloInstalacoes18)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesUnidade18"
                  v-model="formulario.InstalacoesUnidade18"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesQuantidade18"
                  v-model="formulario.InstalacoesQuantidade18"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorInicial18"
                      v-model="formulario.InstalacoesValorInicial18"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorResidual18"
                      v-model="formulario.InstalacoesValorResidual18"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesVidaUtil18"
                  v-model="formulario.InstalacoesVidaUtil18"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesBovinoCultura18"
                  v-model="formulario.InstalacoesBovinoCultura18"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloInstalacoes19"
                  placeholder="Itens"
                  v-model="formulario.TituloInstalacoes19"
                  background-color="white"
                  @input="emitirMudancaDeTitulo19(formulario.TituloInstalacoes19)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesUnidade19"
                  v-model="formulario.InstalacoesUnidade19"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesQuantidade19"
                  v-model="formulario.InstalacoesQuantidade19"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorInicial19"
                      v-model="formulario.InstalacoesValorInicial19"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorResidual19"
                      v-model="formulario.InstalacoesValorResidual19"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesVidaUtil19"
                  v-model="formulario.InstalacoesVidaUtil19"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesBovinoCultura19"
                  v-model="formulario.InstalacoesBovinoCultura19"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloInstalacoes20"
                  placeholder="Itens"
                  v-model="formulario.TituloInstalacoes20"
                  background-color="white"
                  @input="emitirMudancaDeTitulo20(formulario.TituloInstalacoes20)"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Unidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesUnidade20"
                  v-model="formulario.InstalacoesUnidade20"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesQuantidade20"
                  v-model="formulario.InstalacoesQuantidade20"
                  type="number"
                  background-color="white"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorInicial20"
                      v-model="formulario.InstalacoesValorInicial20"
                      type="number"
                      background-color="white"
                      label="R$/Unidade"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="InstalacoesValorResidual20"
                      v-model="formulario.InstalacoesValorResidual20"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesVidaUtil20"
                  v-model="formulario.InstalacoesVidaUtil20"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="InstalacoesBovinoCultura20"
                  v-model="formulario.InstalacoesBovinoCultura20"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Taxa de juros para calcular o custo do capital imobilizado em instalações e benfeitorias</b>
          </span>
        </div>
        <v-divider></v-divider>
        <v-layout align-center justify row wrap>
          <v-flex xs6 sm5 md5>
            <v-text-field
              name="TaxaJurosInstalacoes"
              v-model="formulario.TaxaJurosInstalacoes"
              type="number"
              background-color="white"
              label="% anual"
              box
            ></v-text-field>
            {{form}}
          </v-flex>
        </v-layout>
      </v-flex>
    </v-form>
  </v-panel>
</template>
<script>
/* eslint-disable */
import DadosRecursosInstalacoes from "../../class/DadosRecursosInstalacoes.js";
import { EventBus } from "../../event-bus.js";

export default {
  inject: ["$validator"],
  data: () => ({
    formulario: new DadosRecursosInstalacoes(),
    panel: [],
    simulation: ''
  }),
  mounted() {
    var self = this;
    this.$db.simulation.get(this.$route.params.code, function(s) {
      self.simulation = s;
    });
  },
  computed: {
    form: function() {
      this.$db.simulation.get({ code: this.simulation.code }, dado => {
        this.formulario = new DadosRecursosInstalacoes(dado.dadosRecursosInstalacoes);
      });
    }
  },
  methods: {
    clear() {
      this.formulario = {
        formulario: Object.assign(this.$data, this.$options.data.apply())
      };
      this.$validator.reset();
    },

    emitirMudancaDeTitulo1(titulo1) {
      EventBus.$emit("titulo-instalacoes01", titulo1);
    },
    emitirMudancaDeTitulo2(titulo2) {
      EventBus.$emit("titulo-instalacoes02", titulo2);
    },
    emitirMudancaDeTitulo3(titulo3) {
      EventBus.$emit("titulo-instalacoes03", titulo3);
    },
    emitirMudancaDeTitulo4(titulo4) {
      EventBus.$emit("titulo-instalacoes04", titulo4);
    },
    emitirMudancaDeTitulo5(titulo5) {
      EventBus.$emit("titulo-instalacoes05", titulo5);
    },
    emitirMudancaDeTitulo6(titulo6) {
      EventBus.$emit("titulo-instalacoes06", titulo6);
    },
    emitirMudancaDeTitulo7(titulo7) {
      EventBus.$emit("titulo-instalacoes07", titulo7);
    },
    emitirMudancaDeTitulo8(titulo8) {
      EventBus.$emit("titulo-instalacoes08", titulo8);
    },
    emitirMudancaDeTitulo9(titulo9) {
      EventBus.$emit("titulo-instalacoes09", titulo9);
    },
    emitirMudancaDeTitulo10(titulo10) {
      EventBus.$emit("titulo-instalacoes10", titulo10);
    },
    emitirMudancaDeTitulo11(titulo11) {
      EventBus.$emit("titulo-instalacoes11", titulo11);
    },
    emitirMudancaDeTitulo12(titulo12) {
      EventBus.$emit("titulo-instalacoes12", titulo12);
    },
    emitirMudancaDeTitulo13(titulo13) {
      EventBus.$emit("titulo-instalacoes13", titulo13);
    },
    emitirMudancaDeTitulo14(titulo14) {
      EventBus.$emit("titulo-instalacoes14", titulo14);
    },
    emitirMudancaDeTitulo15(titulo15) {
      EventBus.$emit("titulo-instalacoes15", titulo15);
    },
    emitirMudancaDeTitulo16(titulo16) {
      EventBus.$emit("titulo-instalacoes16", titulo16);
    },
    emitirMudancaDeTitulo17(titulo17) {
      EventBus.$emit("titulo-instalacoes17", titulo17);
    },
    emitirMudancaDeTitulo18(titulo18) {
      EventBus.$emit("titulo-instalacoes18", titulo18);
    },
    emitirMudancaDeTitulo19(titulo19) {
      EventBus.$emit("titulo-instalacoes19", titulo19);
    },
    emitirMudancaDeTitulo20(titulo20) {
      EventBus.$emit("titulo-instalacoes20", titulo20);
    }
  }
};
</script>
<style scoped>
h2 {
  color: #00695c;
}

.botaoNone {
  border: solid black 1px;
  position: fixed;
  margin-bottom: 0;
  z-index: 997;
  bottom: 45px;
  right: 24px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

@media screen and (max-width: 991px) {
  h2 {
    color: #00695c;
  }
  .container {
    position: relative;
    text-align: center;
    background-color: #00695c;
    min-height: 100vh;
    max-width: none;
    color: azure;
  }
  .panel {
    margin-top: 1%;
    padding-left: 2%;
    padding-right: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 15px black;
  }
  .form {
    margin-top: 2%;
    min-width: 100%;
  }
  .text-field {
    background-color: blue;
    font-size: 2px;
  }
  .select {
    background-color: blue;
    font-size: 2px;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }
  .button {
    float: right;
  }
  .divider {
    text-align: center;
    font-size: 130%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    margin-top: 5%;
    margin-left: 5%;
    font-size: 110%;
  }
}

@media screen and (min-width: 992px) {
  h2 {
    color: #00695c;
  }
  .container {
    margin-top: 2%;
    text-align: center;
    background-color: #00695c;
    min-height: 100vh;
    max-width: none;
    color: azure;
  }
  .panel {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 10px black;
  }
  .panelGrafico {
    width: 70%;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }
  .button {
    float: right;
  }
  .divider {
    text-align: center;
    font-size: 180%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    font-size: 150%;
    margin-top: 5%;
    margin-left: 5%;
  }
  .layout {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>